'use strict';

module.exports = {
    SIGN: 'Sign',
    SIGN_JOIN: 'Sign In or Join for Free!',
    EMAIL_EXISTS: 'This email already exists.',
    INVALID_EMAIL: 'Please enter a valid Email Address',
    INVALID_FIRST_NAME: 'Please enter a valid First Name',
    INVALID_LAST_NAME: 'Please enter a valid Last Name',
    INVALID_PASSWORD: 'Please enter 6 - 20 characters (A-Z, a-z, 0-9 only)',
    INVALID_REPASSWORD: 'Passwords are not the same',
    INVALID_VALID_CODE: 'Please enter valid Code',
    UNAVIALABLE_SERVICE: 'Service is unavailable, please retry again later.',
    EMPTY_VALID_CODE: 'Type the characters you see in the picture',
    NOT_MEMBER: 'Not a Member?',
    ALREADY_MEMBER: 'Already an AliExpress/Alibaba Member?',
    EMAIL: 'Email address',
    CONTACT_NAME: 'Contact Name:',
    FIRST_NAME: 'First Name',
    LAST_NAME: 'Last Name',
    PASSWORD: 'Password',
    REPASSWORD: 'Reenter Password:',
    EMPTY_CODE: 'Enter the Code Shown:',
    REFRESH: 'Refresh',
    CREATE_MY_ACCOUNT: 'Create Account',
    NAME: 'Name',
    VERIFICATION: 'Verification code',
    AGREE_MENT: 'By creating an account, you agree to the',
    AE_MEMBER_SHIP: 'AliExpress.com Free Membership Agreement',
    AND: 'and',
    PRIVACY_POLICY: 'Privacy Policy',
    SLIDE_SUBMIT: 'SLIDE RIGHT TO VERIFY',
    SLIDE_SUBMIT_TIPS: 'Success',
    LOADING: 'Loading…',
    SLIDE_SUBMIT_ERROR_TIPS: 'Slide right to verify',
    SHOP_NOW: 'SHOP NOW',
    SIGN_IN: 'Sign In',
    REGISTER_SMS: 'Register with SMS',
    REGISTER_EMAIL: 'Register with Email',
    PHONE_NUMBER: 'Phone number',
    VALID_NUMBER: 'Please input a valid phone number.',
    SEND_SMS_CODE: 'Send SMS code',
    SMS_POLICY: 'We will send a verification code via SMS to the phone number you entered. Make sure both the country code and phone number are correct.',
    SEND_TO: 'We have sent the code to',
    VERIFICATION_RECEIVED: 'Enter the verification code you received or',
    EDIT_NUMBER: 'edit the number.',
    RESEND_CODE: 'Resend code',
    LAST_STEP: 'Last Step',
    SET_SIGN_IN_PASSWORD: 'Please set a Sign In password to make your account more secure.',
    INVALID_PHONE_PASSWORD: '6-20 characters (letters and numbers only)',
    NOT_CORRECT_CODE: 'The code is not correct, please try again.',
    SAVE_PASSWORD: 'Save password',
    NO_RECEIVED_CODE: "If you still haven't received the code, try to",
    VIA_EMAIL: 'Register via Email'

};